import { HealthStatusLabel } from '@/types';
import { flagsToEnumArray } from '@/utils/helpers';

const healthStatusLabels = {
  health_status_changed: HealthStatusLabel.StatusChange,
  not_fully_monitored: HealthStatusLabel.NotFullyMonitored,
};

export const healthStatusFlagsToString = (flags: any): string[] => flagsToEnumArray(flags, healthStatusLabels);
